<template>
  <div class="devSupport">
    開発者 HillTop の Quoridorn開発活動を募金で応援してくださる方は<br />
    <a
      target="_blank"
      href="https://www.amazon.co.jp/Amazon%E3%82%AE%E3%83%95%E3%83%88%E5%88%B8-E%E3%83%A1%E3%83%BC%E3%83%AB%E3%82%BF%E3%82%A4%E3%83%97/dp/BT00DHI8G4"
    >
      Amazonギフト券
    </a>
    を以下のメールアドレスを宛先にして送ってください。
    <br />
    quoridorn@gmail.com
    <br /><br />
    開発支援金は効率の良い開発の推進・維持のために利用します。<br />
    以下はこれまでの使い方です。
    <ul>
      <li>
        出前（ピザ）の購入
        <br />→ 家事にかかる時間の削減効果
      </li>
      <li>
        目に当てる温熱器具の購入
        <br />→
        慢性的な眼精疲労対策が消耗品のアイマスクでは対処が間に合わないため
      </li>
      <li>
        野菜・フルーツジュースの購入
        <br />→ 時短のための普段の食生活で偏りがちな栄養バランスを整えるため
      </li>
      <li>
        有料テキストエディタWebStormのライセンス購入費用
        <br />→ とても便利なので開発が楽
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style scoped src="./devSupport.css"></style>
